const initialStatus = {
  // historic: true,
  // attendanceTools: true,
  // knowledgeTree: true,
}
export default function dockReducer(state = initialStatus, action) {
  switch (action.type) {
    case 'SET_ACTIVE_WIDGET':
      return {
        ...state,
        [action.payload.id]: action.payload.widget,
      }
    default:
      return state
  }
}
